import {YesNoDialog} from "../../components/dialogs";
import {toast} from "react-toastify";

export const AmzsVprasanje: any = ({vprasanje}: { vprasanje?: string }) => {
    return <YesNoDialog result={(yn) => {
        toast.info(yn ? 'Izbrali ste DA' : 'Izbrali ste NE');
    }}>
        {vprasanje}
    </YesNoDialog>
};